import React from 'react';
import { colors } from 'globalStyle';
import styled from 'styled-components';
import { Box, Grid } from '@material-ui/core';
import { Title, Text } from 'components/Texts';
import { BlueA } from 'components/Buttons/Ghost';
import LinkedinLogo from 'assets/icons/linkedin-icon.svg';

export default function ProjectTeam({ isDesktop, staff }) {
  return (
    <Grid
      container
      wrap="nowrap"
      style={{
        overflowX: 'auto',
      }}
    >
      {staff.map((person) => (
        <TeamCardContainer
          item
          container
          key={person.name}
          direction="column"
          alignItems="center"
          isDesktop={isDesktop}
        >
          <Box
            width="100%"
            component="img"
            src={person.image}
            alt={`Imagen de ${person.name}`}
            borderRadius="20px 20px 0px 0px"
            height={isDesktop ? '230px' : '144px'}
          />
          <Box
            width="100%"
            padding="0px 20px 15px 20px"
          >
            <Title
              isCenter
              mb={isDesktop ? 10 : 4}
              mt={isDesktop ? 20 : 10}
              size={isDesktop ? 15 : 13}
            >
              {person.name}
            </Title>
            <Text
              isCenter
              mb={isDesktop ? 15 : 7}
              size={isDesktop ? 14 : 12}
            >
              {person.position}
            </Text>
            <Text
              isCenter
              mb={isDesktop ? 15 : 7}
              size={isDesktop ? 14 : 12}
            >
              +51 998 184 596
            </Text>
            <Grid container justify="flex-end" alignItems="center">
              <BlueA
                underline
                target="_blank"
                mr={isDesktop && 18}
                isCenter={!isDesktop}
                fullWidth={!isDesktop}
                color={colors.primary}
                rel="noopener noreferrer"
                href={person.linkedInLink}
                size={isDesktop ? 14 : 12}
              >
                Ver Linkedin
              </BlueA>
              {isDesktop && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={person.linkedInLink}
                >
                  <Box
                    width="30px"
                    height="30px"
                    component="img"
                    src={LinkedinLogo}
                    alt="Logo Linkedin"
                  />
                </a>
              )}
            </Grid>
          </Box>
        </TeamCardContainer>
      ))}
    </Grid>
  );
}

const TeamCardContainer = styled(Grid)((props) => ({
  borderRadius: '20px',
  background: colors.WHITE,
  minWidth: props.isDesktop && '230px',
  width: props.isDesktop ? '230px' : '143px',
  minHeight: props.isDesktop ? '350px' : '217px',
  marginRight: props.isDesktop ? '67px' : '11px',
}));
